import * as swal from 'sweetalert';
import {AccountService} from '../../core/services/AccountService';
export class PasswordResetPageComponent implements ng.IComponentOptions {
  public controller: any = PasswordResetController;
  public template: string =
    `<div class="container container-fluid">
        <breadcrumb tree="$ctrl.tree"></breadcrumb>
        <div class="wrapper row">
        <div class="col-md-3 sidebar">
          <div class="section-header">First Time Login?</div>
          <div class="section-content">User are required to reset their password during first login.</div>
        </div>
        <div class="col-md-9">
        <h2>Reset Password</h2>
        <form name="resetForm" class="form-horizontal form-ckan">
        <div class="form-group">
        <label for="oldPass" class="col-sm-5 control-label">Current Password</label>
        <div class="col-sm-7">
          <input type="password" class="form-control" id="oldPass" ng-model="$ctrl.form.password" placeholder="Current Password" required>
        </div>
        </div>
        <div class="form-group">
        <label for="newPass" class="col-sm-5 control-label">New Password</label>
        <div class="col-sm-7">
        <input type="password" class="form-control" ng-model="$ctrl.form.newPassword" id="newPass" placeholder="New Password" required>
        <ng-password-meter password="$ctrl.form.newPassword" strength="$ctrl.strength"></ng-password-meter>
        </div>
        </div>
        <div class="form-group">
        <label for="newPass2" class="col-sm-5 control-label">Repeat New Password</label>
        <div class="col-sm-7">
        <input type="password" class="form-control" ng-model="$ctrl.form.newPassword2" ng-blur="$ctrl.passCheck()" id="newPass2" placeholder="Repeat New Password" required>
        <span class="text-warning" ng-show="$ctrl.error.password">Password not match</span>
        </div>
        </div>
        </form>
        <div class="control-panel">
        <button class="btn btn-primary pull-right" ng-click="resetForm.$valid && $ctrl.update()">Submit</button>
        </div>
        </div>
        </div>
      </div>`;
}

interface IPasswordResetForm {
  password: String;
  newPassword: String;
  newPassword2: String;
}

export class PasswordResetController {
  public static $inject: Array<string> = ["AccountService", "$location", "$window"];
  public tree: Array<Object>;
  public form: IPasswordResetForm;
  public error: any;
  public strength: number;
  constructor(public account: AccountService, private $location: ng.ILocationService, private $window: ng.IWindowService) {
    this.tree = [
      {name: "Password Reset", path:"#/password-reset", active: true}
    ]
    this.error = {};
    this.form = {password:"",newPassword:"",newPassword2:""};
  }
  public update() {
    if (this.strength < 50) {
      swal("Sorry!", "Please use stronger password", "warning");
      return;
    }
    if(this.form.password && this.form.newPassword && this.form.newPassword == this.form.newPassword2){
      this.account.resetPassword(this.form).then(d => {
        swal({
          title: "Success!",
          text: "Your Password has been updated, please re-login with your new password",
          type: "success"
        }, d => {
          this.account.logout();
          this.$window.open("#/login", "_top");
        });
      })
      .catch(error => {
        if (error.data.code == 101)
          swal("Oops!", "Your current Password is incorrect", "warning");
        else
          swal("Sorry!", "We failed to update your password, please try again later", "warning");
      })
    }
  }

  public passCheck() {
    if(this.form.newPassword && this.form.newPassword2 && this.form.newPassword != this.form.newPassword2){
      this.error.password = true;
    }
    else {
      this.error.password = false;
    }
  }

}
